import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SharedModule } from '@app/shared/shared.module';
import { DispatcherComponent } from '@app/features/dispatcher/dispatcher.component';
import { UnauthorizedComponent } from '@app/features/unauthorized/unauthorized.component';
import { InvoicesRoutingModule } from '@app/features/invoices/invoices-routing.module';
import { InvoiceForwardComponent } from '@app/features/invoices/actions/forward/invoice-forward.component';
import { InvoiceCancelComponent } from '@app/features/invoices/actions/cancel/invoice-cancel.component';
import { InvoiceDetailComponent } from '@app/features/invoices/detail/invoice-detail.component';
import { InvoiceDetailActionsComponent } from '@app/features/invoices/detail/actions/invoice-detail-actions.component';
import { InvoiceLateComponent } from '@app/features/invoices/list/late/invoice-list-late.component';
import { InvoiceListComponent } from '@app/features/invoices/list/invoice-list.component';
import { InvoiceListDispatchedComponent } from '@app/features/invoices/list/dispatched/invoice-list-dispatched.component';
import { InvoiceListRejectedComponent } from '@app/features/invoices/list/rejected/invoice-list-rejected.component';
import { InvoiceListVoucherValidatedComponent } from '@app/features/invoices/list/voucher-validated/invoice-list-voucher-validated.component';
import { InvoiceListVoucherWorkflowComponent } from '@app/features/invoices/list/voucher-workflow/invoice-list-voucher-workflow.component';
import { InvoicePdfViewerComponent } from '@app/features/invoices/detail/pdf-viewer/invoice-pdf-viewer.component';
import { InvoiceSearchComponent } from '@app/features/invoices/list/search/invoice-list-search.component';
import { InvoiceTraceabilityComponent } from '@app/features/invoices/detail/traceability/invoice-traceability.component';
import { InvoiceTraceabilityWorkflowsComponent } from '@app/features/invoices/detail/traceability/invoice-traceability-workflows/invoice-traceability-workflows.component';
import { InvoiceVoucherComponent } from '@app/features/invoices/actions/voucher/invoice-voucher.component';
import { InvoiceVoucherProcessComponent } from '@app/features/invoices/actions/voucher/invoice-voucher-process/invoice-voucher-process.component';
import { InvoiceVoucherFormComponent } from '@app/features/invoices/actions/voucher/invoice-voucher-form/invoice-voucher-form.component';
import { AnalysisModule } from '../analysis/analysis.module';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { InvoiceListPPRErrorsComponent } from './actions/listPPRErrors/invoice-list-pprerrors/invoice-list-pprerrors.component';
import { InvoiceListPromotionWorkflowComponent } from './list/promotion-workflow/invoice-list-promotion-workflow.component';
import { MatCardModule } from '@angular/material/card';
import { InvoiceSelectRef1Component } from './actions/invoice-select-ref1/invoice-select-ref1.component';
import { InvoiceDeductionComponent } from './detail/invoice-panels/invoice-deduction/invoice-deduction.component';
import { InvoiceDelegationComponent } from './detail/invoice-panels/invoice-delegation/invoice-delegation.component';
import { InvoiceAmendmentComponent } from './detail/invoice-panels/invoice-amendment/invoice-amendment.component';
import { InvoiceExpenseComponent } from './detail/invoice-panels/invoice-expense/invoice-expense.component';

@NgModule({
  declarations: [
    DispatcherComponent,
    InvoiceCancelComponent,
    InvoiceDetailComponent,
    InvoiceDetailActionsComponent,
    InvoiceForwardComponent,
    InvoiceLateComponent,
    InvoiceListComponent,
    InvoiceListDispatchedComponent,
    InvoiceListRejectedComponent,
    InvoiceListVoucherValidatedComponent,
    InvoiceListVoucherWorkflowComponent,
    InvoicePdfViewerComponent,
    InvoiceSearchComponent,
    InvoiceTraceabilityComponent,
    InvoiceTraceabilityWorkflowsComponent,
    InvoiceVoucherComponent,
    InvoiceVoucherProcessComponent,
    InvoiceVoucherFormComponent,
    UnauthorizedComponent,
    InvoiceListPPRErrorsComponent,
    InvoiceListPromotionWorkflowComponent,
    InvoiceSelectRef1Component,
    InvoiceDeductionComponent,
    InvoiceDelegationComponent,
    InvoiceAmendmentComponent,
    InvoiceExpenseComponent,
  ],
  imports: [
    AnalysisModule,
    CommonModule,
    InvoicesRoutingModule,
    SharedModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatChipsModule,
    MatRadioModule,
    MatDialogModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
  ],
  exports: [
    MatFormFieldModule,
    MatInputModule,
    UnauthorizedComponent,
    DispatcherComponent,
  ],
})
export class InvoicesModule {}
